import { Spinner } from "components/shared/Spinner";
import { FC, ReactNode, Suspense, VFC } from "react";
import { MessageDescriptor, useIntl } from "react-intl";
import { Message } from "shared/components/Message";
import { mapMessages } from "shared/mapMessages";

const messages = mapMessages("components.shared.LoadingRegionSuspense", {
    loadingText: "Loading {contentName}.",
});

type Props = {
    children: ReactNode,
    contentName: MessageDescriptor | string;
};

export const LoadingRegionSuspense: VFC<Props> = ({
    children,
    contentName,
}) => (
    <Suspense fallback={<LoadingFallback contentName={contentName} />}>
        {children}
    </Suspense>
);

const LoadingFallback: FC<Pick<Props, "contentName">> = ({ contentName }) => {
    const intl = useIntl();
    const messageValues: { contentName: string } = { contentName: typeof contentName === "string" ? contentName : intl.formatMessage(contentName) };

    return <>
        <div role="status" aria-live="polite">
            <div><Spinner className="mr-1" aria-hidden="true" /> <Message message={messages.loadingText} values={messageValues} /></div>
        </div>
        <div aria-busy="true" />
    </>;
};
